<template>
  <el-dialog
    title="导出记录下载"
    :visible.sync="visible"
    width="920px"
    append-to-body
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      stripe
      :data="list">
      <el-table-column
        fixed="left"
        min-width="140"
        label="任务编号"
        prop="id"></el-table-column>
      <el-table-column
        min-width="80"
        label="失败数"
        prop="failedCount"></el-table-column>
      <el-table-column
        min-width="80"
        label="成功数"
        prop="successfulCount"></el-table-column>
      <el-table-column
        min-width="80"
        label="总数"
        prop="total"></el-table-column>
      <el-table-column
        min-width="150"
        label="创建时间">
        <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
      </el-table-column>
      <el-table-column
        min-width="150"
        label="完成时间">
        <template slot-scope="{ row }">{{ row.doneTime | dateformat() }}</template>
      </el-table-column>
      <el-table-column
        label="状态"
        min-width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.status | orderUploadStatusType()">{{ row.status | orderUploadStatusName() }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="70">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-button type="text">
              更多
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="!row.resultFileUrl"
                @click.native="downloadItem(row)">下载文件</el-dropdown-item>
              <el-dropdown-item @click.native="deleteItem(row)">删除文件</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="handleCurrentChange(1)">刷新</el-button>
      <el-button
        :loading="loading"
        @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Download from '@/service/download'
export default {
  name: 'DownloadOrderFileModal',
  props: {
    taskType: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, status: null },
      total: 0,
      list: []
    }
  },
  methods: {
    fetch() {
      this.visible = true
      this.fetchList()
    },
    handleClosed() {
      this.list = []
      this.config.pageNum = 1
      this.total = 0
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Download.getbatchtasks({ ...this.config, taskType: this.taskType })
        .then(res => {
          const { result, message, total, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    downloadItem(row) {
      window.open(row.resultFileUrl)
    },
    deleteItem(row) {
      this.$confirm(`该操作将删除导出任务, 是否继续?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Download.deletebatchtask({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
